import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { CircularProgress } from "@mui/material";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";

export default function Grupo(props) {
  const history = props.history;
  const [grupoId] = useState(Number(props.match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({ nome: "", ativo: false });
  const [dadosMembro, setDadosMembro] = useState({ nome: "", cpf: "" });
  const { notification } = useContext(AppContext);
  const [membros, setMembros] = useState([]);
  const [profsBusca, setProfsBusca] = useState([]);
  const [membroSelecionado, setMembroSelecionado] = useState(false);

  useEffect(() => {
    if (grupoId > 0) {
      carregar();
      carregarMembros();
    }
  }, []);

  const carregar = () => {
    setCarregando(true);

    api
      .get("grupos/carregar", { id: grupoId })
      .then((res) => {
        setDados(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar grupo");
        setCarregando(false);
      });
  };

  const carregarMembros = () => {
    setCarregando(true);

    api
      .get("grupos/membros", { grupoId: grupoId })
      .then((res) => {
        setMembros(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível membros");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    let dadosParams = dados;
    dadosParams.nome = params.nome;
    dadosParams.ativo = params.ativo;

    if (grupoId > 0) dadosParams.id = grupoId;
    setDados(dadosParams);

    if (grupoId === 0) {
      api
        .put("grupos/inserir", dadosParams)
        .then((res) => {
          notification("success", "Grupo inserido!");
          setDados({ nome: "", ativo: false });
          history.push(`/app/grupo`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("grupos/editar", dadosParams)
        .then((res) => {
          notification("success", "Grupo Editado!");
          setDados({ nome: "", ativo: false });
          history.push(`/app/grupo`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    title: "Grupo de usuários",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        space: 4,
        value: dados.ativo,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const remover = (id) => {
    api
      .delete("grupos/removerMembro", { usuarioId: id, grupoId: grupoId })
      .then((res) => {
        notification("success", "Membro removido!");
        setMembroSelecionado(false);
        carregarMembros();
      })
      .catch((err) => {
        notification("error", "Não foi possível remover membro");
        setCarregando(false);
      });
  };

  const tableStruc = {
    title: "Membros",
    key: "usuarioId",
    newItemAction: () => setMembroSelecionado(true),

    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
        type: "text",
      },
    ],
    actions: [
      {
        name: "delete",
        icon: "zmdi zmdi-delete",
        action: remover,
      },
    ],
    array: membros,
  };

  const buscar = (params) => {
    let dadosParams = {
      nome: params.nome,
      CPF: params.cpf,
    };

    setDadosMembro(dadosParams);

    setCarregando(true);

    api
      .get("profissionais/listar", dadosParams)
      .then((res) => {
        setProfsBusca(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar profissionais");
        setCarregando(false);
      });
  };

  const fMembro = {
    title: "Novo membro",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dadosMembro.nome,
      },
      cpf: {
        label: "CPF",
        type: "number",
        space: 4,
        value: dadosMembro.cpf,
      },
    },

    submit: {
      label: "Buscar",
      action: buscar,
    },
    close: {
      label: "Fechar",
      action: () => {
        setDadosMembro({ nome: "", cpf: "" });
        setMembroSelecionado(false);
      },
    },
  };

  const adicionarMembro = (id) => {
    api
      .post("grupos/inserirMembro", { usuarioId: id, grupoId: grupoId })
      .then((res) => {
        notification("success", "Membro adicionado!");
        setMembroSelecionado(false);
        carregarMembros();
      })
      .catch((err) => {
        notification("error", "Não foi possível adicionar membro");
        setCarregando(false);
      });
  };

  const tBusca = {
    title: "Profissionais localizados",
    array: profsBusca,
    key: "usuarioId",
    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
        style: { fontWeight: "bolder" },
      },
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
    ],
    actions: [
      {
        name: "add",
        icon: "zmdi zmdi-plus",
        action: adicionarMembro,
      },
    ],
  };

  return (
    <div>
      {!membroSelecionado ? (
        <>
          {carregando ? <CircularProgress /> : <Form formData={fDados} />}
          {grupoId > 0 && (
            <>
              {/* <br />
              <ThemeProvider theme={theme}>
                <Button
                  style={{ margin: "0px 10px 0px 10px" }}
                  variant="contained"
                  sx={{ color: "#FFFF" }}
                  onClick={() => setMembroSelecionado(true)}
                >
                  +
                </Button>
              </ThemeProvider>
              <br />
              <br /> */}
              {carregando ? (
                <CircularProgress />
              ) : (
                <ActionTable structure={tableStruc} />
              )}
            </>
          )}
        </>
      ) : (
        <>
          <Form formData={fMembro} />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tBusca} />
          )}
        </>
      )}
    </div>
  );
}
